import WeaveHelper from "./weavehelper";
import WeaveAPI from "../weaveapi/weaveapi";
import LOCAL_STORAGE from "../_redux/localStorage";

import { binary_to_base58 } from "base58-js";
import { Buffer } from "buffer";
import Web3 from "web3";
import {
	sideChain,
	organization,
	datasets_scope,
	datasets_table,
	weaves_table,
	accounts_table,
	contractAddress,
	feeTokenAddress,
} from "../market/marketplace.json";

const contractAbi = require("../market/WeavePay_abi.json");
const feeTokenAbi = require("../market/FiatTokenV1_abi.json");

async function getMetamaskWallet() {
	if (window.ethereum && !window.web3) {
		window.web3 = new Web3(window.ethereum);
		window.ethereum.enable();
	}

	if (window.ethereum) {
		window.web3 = new Web3(window.ethereum);
		window.ethereum.enable();

		let accounts = await window.ethereum.request({
			method: "eth_requestAccounts",
		});
		if (!accounts || accounts.length === 0) {
			const permissions = await window.ethereum.request({
				method: "wallet_requestPermissions",
				params: [
					{
						eth_accounts: {},
					},
				],
			});
			accounts = await window.ethereum.request({method: "eth_requestAccounts"});
		}
		return accounts[0].toLowerCase();
	} else {
		return null;
	}
}

async function createApi(chain, bootstrapNode) {
	let stateData = LOCAL_STORAGE.loadState() || {};
	const keys = WeaveHelper.Helper.generateKeys();
	const pub = stateData.pub || keys[0];
	const pvk = stateData.pvk || keys[1];

	let { signatures, wallet, sig } = stateData;
	if (!wallet) {
		wallet = await getMetamaskWallet();
	}

	const node = bootstrapNode || sideChain;
	const config = WeaveHelper.Helper.getConfig(node, pub, pvk);
	//console.log(config);
	const nodeApi = new WeaveAPI().create(config);
	await nodeApi.init();

	let key = null;
	if (chain === "solana") {
		key = "solana:" + wallet + ":" + pub;
		if (!signatures || !signatures[key]) {
			if (!signatures) signatures = {};

			const response = await window.solana.connect();
			wallet = response.publicKey.toString().toLowerCase();

			let msg =
				"Please sign this message to confirm you own this wallet\nThere will be no blockchain transaction or any gas fees." +
				"\n\nWallet: " +
				wallet +
				"\nKey: " +
				pub;

			const signature = await window.solana.signMessage(
				new TextEncoder().encode(msg),
				"utf8"
			);
			sig = binary_to_base58(signature.signature);
			signatures[key] = sig;
		} else {
			sig = signatures[key];
		}
	} else if (chain) {
		key = "eth:" + wallet + ":" + pub;
		if (!signatures || !signatures[key]) {
			if (!signatures) signatures = {};
			wallet = await getMetamaskWallet();

			let msg =
				"Please sign this message to confirm you own this wallet\nThere will be no blockchain transaction or any gas fees." +
				"\n\nWallet: " +
				wallet +
				"\nKey: " +
				pub;

			sig = await window.ethereum.request({
				method: "personal_sign",
				params: [wallet, msg],
			});
			signatures[key] = sig;
		} else {
			sig = signatures[key];
		}
	}

	const credentials = sig
		? {
				account: chain + ":" + wallet,
				sig: sig,
				template: "*",
				role: "*",
		  }
		: null;

	LOCAL_STORAGE.saveState({
		...stateData,
		signatures: signatures,
	});

	return { pub, nodeApi, credentials, wallet };
}

async function readDatasets() {
	const { pub, nodeApi, credentials, wallet } = await createApi();
	const session = await nodeApi.login(organization, pub, datasets_scope);
	const datasets = await nodeApi.read(
		session,
		datasets_scope,
		datasets_table,
		null,
		WeaveHelper.Helper.Options.READ_DEFAULT_NO_CHAIN
	);
	//console.log(datasets)
	return datasets;
}

async function readWeaves(filters) {
	const { pub, nodeApi, credentials, wallet } = await createApi();
	const session = await nodeApi.login(organization, pub, datasets_scope);
	return await nodeApi.read(
		session,
		datasets_scope,
		weaves_table,
		null,
		WeaveHelper.Helper.Options.READ_DEFAULT_NO_CHAIN
	);
}

async function readAccounts() {
	const { pub, nodeApi, credentials, wallet } = await createApi();
	const session = await nodeApi.login(organization, pub, datasets_scope);
	return await nodeApi.read(
		session,
		datasets_scope,
		accounts_table,
		null,
		WeaveHelper.Helper.Options.READ_DEFAULT_NO_CHAIN
	);
}

export const downloadPaid = async (dataset) => {
	try {
		//console.log(dataset)

		//TODO: do only once
		const contract = await new window.web3.eth.Contract(
			contractAbi,
			contractAddress
		);
		const feeToken = await new window.web3.eth.Contract(
			feeTokenAbi,
			feeTokenAddress
		);

		const DECIMALS = 6; //TODO: !!! Very important! get from token definition
		const amount = dataset.price;
		const did = dataset.did;

		const chain = dataset.token.substr(0, dataset.token.indexOf(":"));
		const { pub, nodeApi, credentials, wallet } = await createApi(chain, dataset.weave?.bootstrap_node);

		console.log("Downloading " + did + " for " + wallet);
		const session = await nodeApi.login(
			organization,
			pub,
			datasets_scope,
			credentials
		);

		let lockedFunds = 0;
		let paid = 0;

		try {
			const getPrice = contract.methods.getDataset(did);
			const expected = await getPrice.call();

			//console.log("Expected", expected);
			//console.log("To pay", amount * Math.pow(10, DECIMALS));
			const getLocked = contract.methods.getLocked(did, wallet);
			const getPaid = contract.methods.getPaid(did, wallet);
			lockedFunds = await getLocked.call();
			paid = await getPaid.call();
			//console.log("locked", lockedFunds);
			//console.log("paid", paid);
		} catch (e) {
			console.log("Payments check failed " + e.toString());
		}

		try {
			const getDataset = contract.methods.getDataset(did);
			const getReply = await getDataset.call();
			//console.log(getReply)

			if (paid > 0 || lockedFunds > 0) {
				console.log("Already paid");
			} else {
				const approve = feeToken.methods.approve(
					contractAddress,
					amount * Math.pow(10, DECIMALS)
				);
				const approveReply = await approve.send({ from: wallet });
				console.log(approveReply);

				const pay = contract.methods.pay(did, amount * Math.pow(10, DECIMALS));
				const reply = await pay.send({ from: wallet });
				console.log(reply);
			}

			//const locked = contract.methods.getLocked(did, wallet);
			//const result = await locked.call();
			//console.log(result)
		} catch (e) {
			console.log("Payments contract interaction failed " + e.toString());
		}

		const res = await nodeApi.downloadDataset(
			session,
			did,
			WeaveHelper.Helper.Options.READ_DEFAULT_NO_CHAIN
		);
		console.log(res);

		const fileName = did;
		const data = new Blob([Buffer.from(res.data, "base64")], {
			type: "application/zip",
		});
		var url = URL.createObjectURL(data);
		var hlink = document.createElement("a");
		hlink.href = url;
		hlink.download = fileName;
		hlink.click();
	} catch (e) {
		console.log(e);
	}
};

export const downloadPrePaid = async (dataset) => {
	try {
		//console.log(dataset)

		const did = dataset.did;

		const chain = dataset.token.substr(0, dataset.token.indexOf(":"));
		const { pub, nodeApi, credentials, wallet } = await createApi(chain, dataset.weave?.bootstrap_node);

		console.log("Downloading " + did + " for " + wallet);
		const session = await nodeApi.login(
			organization,
			pub,
			datasets_scope,
			credentials
		);

		const res = await nodeApi.downloadDataset(
			session,
			did,
			WeaveHelper.Helper.Options.READ_DEFAULT_NO_CHAIN
		);
		console.log(res);

		const fileName = did;
		const data = new Blob([Buffer.from(res.data, "base64")], {
			type: "application/zip",
		});
		var url = URL.createObjectURL(data);
		var hlink = document.createElement("a");
		hlink.href = url;
		hlink.download = fileName;
		hlink.click();
	} catch (e) {
		console.log(e);
	}
};

const MarketApiHelper = {
	readWeaves,
	readDatasets,
	downloadPaid,
	downloadPrePaid,
};

export default MarketApiHelper;
